export default class BaseEventModel {
  public readonly isSdk: boolean = true; // temporary field to indicate events sent from Analytics SDK

  /** Initializes a new instance of the BaseEventModel class. */
  protected constructor(
    public readonly eventName: string,
    public readonly timestamp: number,
    public readonly clientId: string,
    public readonly sessionId: string,
    public readonly merchantId: string,
    public readonly shopperCountryCode: string,
    public readonly category: string, // e.g. Browsing Funnel, Checkout Funnel
    public readonly cdn: string, // used by DTS to load configuration from particular server instance
  ) {
    // todo: validate required (all of the above) fields
  }
}
